import React from "react";
import { connect } from "react-redux";
import {
  saveDesign,
  updateQuantity,
  updateSavings,
  displayLoginPrompt
} from "../../actions";
import { bindActionCreators } from "redux";
import Preview from "./Preview";
import LoadingThrobber from "../Layout/Icons/LoadingThrobber";
import BackButton from "./BackButton";
import Cart from "./Cart";
import ProofOptions from "./ProofOptions";
//import DigitalProof from './DigitalProof'     // 2019-05-14 changing photos to NOT have automatic proof but to ask instead
import LargePlate from "./LargePlate";
import RepoussePlate from "./RepoussePlate";
import SelectQuantity from "./SelectQuantity";
import Upcharges from "./Upcharges";
import Comments from "./Comments";
import AddToCart from "./AddToCart";
import "./Review.css";

class Review extends React.Component {
  state = {
    selectedProofOption: null,
    redirecting: false,
    comments: null,
    hasPhotos: false,
    hasArt: false,
    isRepousse: false,
    orderId: null,
    isZoomed: false,
    proofOptionError: false,
    showNotification: false
  };

  componentDidMount() {
    // Check if any layers have custom photos added to them
    let numPhotos = 0,
      numArt = 0,
      isRepousse = false;

    this.props.design.layer_set.forEach((layer) => {
      if (layer.image_elements.length) {
        layer.image_elements.forEach((element) => {
          if (element.type === "photo") {
            numPhotos++;
          } else if (element.type === "art") {
            numArt++;
          }
        });
      }
      if (layer.text_elements.length > 0 && layer.is_repousse) {
        isRepousse = true;
      }
    });

    if (numArt > 0) {
      this.setState({ hasArt: true });
    }

    if (numPhotos > 0) {
      this.setState({ hasPhotos: true });
    }

    if (isRepousse) {
      this.setState({ isRepousse: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.minimumQuantity !== this.props.minimumQuantity) {
      this.setState({
        quantity: this.props.minimumQuantity
      });
    }
  }

  handleAddToCart = () => {
    // Check if user has selected a proof option
    if (!this.state.selectedProofOption) {
      // Show error and notification
      this.setState({
        proofOptionError: true,
        showNotification: true
      });

      // Scroll to proof options section
      const proofOptionsElement = document.querySelector('.proof-options');
      if (proofOptionsElement) {
        proofOptionsElement.scrollIntoView({ behavior: 'smooth' });
      }

      // Hide notification after 3 seconds
      setTimeout(() => {
        this.setState({ showNotification: false });
      }, 3000);

      return;
    }

    // getting largePlate from the design here
    const largePlate = this.props.design.largePlate;

    let proof = null;

    if (this.state.hasPhotos) {
      // 2019-05-14 changing photos to NOT have automatic proof but to ask instead
      //proof = 'PhotoDigitalProofCharge'
      if (this.state.selectedProofOption === "digitalproof") {
        proof = "RegularDigitalProofCharge";
      }
    } else if (this.state.hasArt) {
      proof = "CustomArtCharge";
      if (this.state.selectedProofOption === "digitalproof") {
        // this will signal its custom art WITH proof
        proof = "CustomArtProofCharge";
      }
    } else if (this.state.selectedProofOption === "digitalproof") {
      proof = "RegularDigitalProofCharge";
    }

    const data = {
      quantity: this.state.quantity,
      comments: this.state.comments ? this.state.comments : "",
      largePlate,
      proof,
      orderId: null
    };

    const isAdmin = this.props.user.loggedIn && this.props.user.isAdmin;
    if (isAdmin) {
      if (this.state.orderId && this.state.orderId.length > 0) {
        //for admins adding an item to someone else's cart
        data.orderId = this.state.orderId;
      } else if (this.props.admin.action.orderID) {
        data.orderId = this.props.admin.action.orderID;
        data.redirect = this.props.admin.action.return;
      }
    }

    this.props.addToCart(data);
    this.setState({
      redirecting: true
    });
  };

  overwriteDesign = () => {
    const data = {
      overwrite: true,
      orderItemId: this.props.admin.action.orderItemID,
      orderNumber: this.props.admin.action.orderNumber,
      purchasedItemID: this.props.admin.action.purchasedItemID,
      redirect: this.props.admin.action.return
    };
    this.props.saveDesign(data);
  };

  handleSelectProofOption = (value) => {
    this.setState({
      selectedProofOption: value,
      proofOptionError: false
    });
  };

  handleUpdateQuantity = (quantity) => {
    this.props.updateQuantity(quantity);
    this.setState({
      quantity
    });
  };

  handleUpdateSavings = (savings) => {
    this.props.updateSavings(savings);
  };

  addComments = (comments) => {
    this.setState({
      comments
    });
  };

  setOrderId = (event) => {
    this.setState({
      orderId: event.target.value
    });
  };

  handleZoom = () => {
    this.setState((prevState) => ({
      isZoomed: !prevState.isZoomed
    }));
  };

  render() {
    let price = null,
      initialPrice = null,
      inititalSavings = 0,
      originalPrice = 0,
      currentPrice = 0;

    if (this.props.pricebreaksList) {
      // Find the closest price break based on the current quantity
      const pricebreakKeys = Object.keys(this.props.pricebreaksList);
      const findPricebreak = pricebreakKeys.filter((value) => {
        return parseInt(value, 10) <= this.props.quantity;
      });

      const closestPriceBreak = findPricebreak.pop();

      // The current price per unit based on the quantity pricebreak
      price = this.props.pricebreaksList[closestPriceBreak];
      // The base price used to calculate % savings
      initialPrice = this.props.pricebreaksList[this.props.minimumQuantity];

      originalPrice = (initialPrice * this.props.minimumQuantity).toFixed(2);
      currentPrice = (price * this.props.minimumQuantity).toFixed(2);
      inititalSavings = ((originalPrice - currentPrice) / originalPrice) * 100;
    }

    const isAdmin = this.props.user.loggedIn && this.props.user.isAdmin;
    const isAdminEditing =
      isAdmin && this.props.admin.action.actionType === "edit";
    const isAdminCopying =
      isAdmin && this.props.admin.action.actionType === "copy";
    const isAdminEditingOrCopying = isAdminEditing || isAdminCopying;

    return (
      <div className="review-container">
        {/* Notification component */}
        {this.state.showNotification && (
          <div className="proof-notification">
            <div className="proof-notification__content">
              Please select either "Print As Is" or "Digital Proof" before adding to cart.
            </div>
          </div>
        )}

        <BackButton
          routeId={this.props.routeId}
          location={this.props.location}
        />

        <Cart />

        <div className="review">
          <Preview
            handleZoom={this.handleZoom}
            isZoomed={this.state.isZoomed}
          />

          <div className="review__details">
            {!isAdminEditing && (
              <>
                <div className="proof-options-header">
                  <h2>Select a Proof Option:</h2>
                  <p className="required-text">* Required</p>
                </div>

                {this.state.proofOptionError && (
                  <div className="proof-options-error">
                    Please select either "Print As Is" or "Digital Proof" before adding to cart.
                  </div>
                )}

                <ProofOptions
                  selectedProofOption={this.state.selectedProofOption}
                  handleSelectProofOption={this.handleSelectProofOption}
                  hasArt={this.state.hasArt}
                  showError={this.state.proofOptionError}
                />
              </>
            )}

            {
              //this.state.hasPhotos &&                      // 2019-05-14 - removing mandatory proof for photos
              //<DigitalProof amount="15" type="Photos" />
            }

            {this.props.design.largePlate && <LargePlate />}

            {this.state.isRepousse && <RepoussePlate />}

            {this.props.pricebreaksLoading ? (
              <LoadingThrobber text="Loading Pricing" />
            ) : (
              ""
            )}

            {this.props.pricebreaksList && (
              // Make sure base price has been set from price breaks before loading quantity selection
              <SelectQuantity
                selectedProofOption={this.state.selectedProofOption}
                price={price}
                quantity={this.props.quantity}
                pricebreaks={this.props.pricebreaksList}
                minimumQuantity={this.props.minimumQuantity}
                quantityIncrement={this.props.quantityIncrement}
                totalSavings={inititalSavings}
                initialPrice={initialPrice}
                hasArt={this.state.hasArt}
                hasPhotos={this.state.hasPhotos}
                isRepousse={this.state.isRepousse}
                largePlate={this.props.design.largePlate}
                handleUpdateQuantity={this.handleUpdateQuantity}
                handleUpdateSavings={this.handleUpdateSavings}
              />
            )}

            {this.props.pricebreaksList &&
              this.props.upchargesList &&
              this.props.upchargesList.length > 0 && (
                <Upcharges upchargesList={this.props.upchargesList} />
              )}

            {!isAdminEditing && (
              <Comments handleAddComments={this.addComments} />
            )}

            {this.props.pricebreaksList &&
              isAdmin &&
              !isAdminEditingOrCopying && (
                <div className="admin-add-to-cart">
                  <p>
                    Cart ID <small>Not the Order Number</small>
                  </p>
                  <p>
                    <input
                      onChange={this.setOrderId}
                      className="input--text"
                      type="text"
                      name="order_id"
                      placeholder="Cart ID"
                    />
                  </p>
                </div>
              )}

            {this.props.pricebreaksList && !isAdminEditingOrCopying && (
              <p className="review__disclaimer">
                By clicking Add to Cart, you agree to our{" "}
                <a
                  href="/return-policy"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Terms and Conditions
                </a>
              </p>
            )}

            {isAdminEditing && (
              <div>
                <button
                  className="button button--round"
                  onClick={this.overwriteDesign}
                >
                  {this.props.design && this.props.design.isSaving
                    ? "Saving..."
                    : "Overwrite Design"}
                </button>
              </div>
            )}

            {this.props.pricebreaksList && isAdminCopying && (
              <AddToCart
                defaultText={
                  "Add to Existing Order " + this.props.admin.action.orderNumber
                }
                handleAddToCart={this.handleAddToCart}
                isRedirecting={this.props.isRedirecting}
              />
            )}

            {this.props.pricebreaksList && !isAdminEditingOrCopying && (
              <AddToCart
                defaultText="Add to Cart"
                handleAddToCart={this.handleAddToCart}
                isRedirecting={this.props.isRedirecting}
                isDisabled={!this.state.selectedProofOption && !isAdminEditing}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    dirtyDesign: state.dirtyDesign,
    user: state.user,
    isSaving: state.design.present.isSaving,
    isRedirecting: state.design.present.isRedirecting,
    admin: state.admin
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      saveDesign: saveDesign.request,
      updateQuantity,
      updateSavings,
      displayLoginPrompt
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Review);
